import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { 
  FiSearch, 
  FiUser, 
  FiCalendar, 
  FiUsers, 
  FiMessageSquare, 
  FiMapPin,
  FiChevronLeft,
  FiChevronRight
} from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import "./home.css";
import "./responsive.css";
import NoDataImage from "../../background.gif";
import FinderSelect from "./FinderSelect";
import AgeMeter from "./AgeMeter";
import MemberPhotoSlider from "../common/MemberPhotoSlider";
import { getUserImages } from "../../utils/userImages";
import { getMinAgeForGender } from "../../utils/dobLimits";
// Hero Desktop & Mobile Banners
import desktopBanner1 from "../../assets/images/banners/desktop-banner-1.jpg";
import desktopBanner2 from "../../assets/images/banners/desktop-banner-2.jpg";
import mobileBanner1 from "../../assets/images/banners/mobile-banner-1.jpg";
import mobileBanner2 from "../../assets/images/banners/mobile-banner-2.jpg";

// Social Proof Avatars
import user1 from "../../assets/images/user/1.jpg";
import user2 from "../../assets/images/user/2.jpg";
import user3 from "../../assets/images/user/3.jpg";
import user4 from "../../assets/images/user/4.jpg";
import user5 from "../../assets/images/user/5.jpg";

const DEFAULT_MIN_AGE = 21;
const DEFAULT_MAX_AGE = 30;
const AGE_SCALE_MIN = 21;
const AGE_SCALE_MAX = 70;

const HERO_SLIDES = [
  {
    id: 1,
    desktop: desktopBanner1,
    mobile: mobileBanner1,
    alt: "Hindu Sanjog - Find Your Perfect Life Partner",
  },
  {
    id: 2,
    desktop: desktopBanner2,
    mobile: mobileBanner2,
    alt: "Hindu Sanjog - Every Match Has a Beautiful Story",
  },
];

const LOOKING_FOR_OPTIONS = [
  { value: "female", label: "Bride" },
  { value: "male", label: "Groom" },
];

const AGE_RANGE_OPTIONS = [
  { value: "18 - 25", label: "18 - 25" },
  { value: "21 - 30", label: "21 - 30" },
  { value: "18 - 35", label: "18 - 35" },
  { value: "25 - 35", label: "25 - 35" },
  { value: "28 - 40", label: "28 - 40" },
  { value: "30 - 50", label: "30 - 50" },
  { value: "21 - 60", label: "21 - 60" },
];

const DEFAULT_CASTES = [
  "Brahmin",
  "Rajput",
  "Maratha",
  "Agarwal",
  "Gupta",
  "Kayastha",
  "Yadav",
  "Jat",
  "Kshatriya",
  "Bania",
  "Maheshwari",
  "Jain",
  "Khatri",
  "Arora",
  "Lingayat",
  "Reddy",
  "Nair",
  "Vanniyar",
  "Other"
];

const MOTHER_TONGUES = [
  "Assamese",
  "Bengali",
  "English",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Marwari",
  "Odia",
  "Punjabi",
  "Sindhi",
  "Tamil",
  "Telugu",
  "Other"
];

const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Delhi / NCR",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Other"
];

export default function Bnner() {
  const [casteOptions, setCasteOptions] = useState(DEFAULT_CASTES);

  const casteSelectOptions = [
    { value: "", label: "Select" },
    { value: "All Hindu", label: "All Hindu Communities" },
    ...casteOptions.map((caste) => ({ value: caste, label: caste })),
  ];

  const sortedMotherTongues = [...MOTHER_TONGUES].sort((a, b) => {
    if (a === "Other") return 1;
    if (b === "Other") return -1;
    return a.localeCompare(b);
  });

  const motherTongueOptions = [
    { value: "", label: "Select" },
    ...sortedMotherTongues.map((lang) => ({ value: lang, label: lang })),
  ];

  const sortedStates = [...INDIAN_STATES].sort((a, b) => {
    if (a === "Other") return 1;
    if (b === "Other") return -1;
    return a.localeCompare(b);
  });

  const stateOptions = [
    { value: "", label: "Select State" },
    ...sortedStates.map((stateName) => ({ value: stateName, label: stateName })),
  ];

  const [formData, setFormData] = useState({
    lookingFor: "female", // "female" -> Bride, "male" -> Groom
    minAge: DEFAULT_MIN_AGE,
    maxAge: DEFAULT_MAX_AGE,
    religion: "Hindu",
    caste: "",
    motherTongue: "",
    state: "",
  });

  const [apiData, setApiData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(!isOpenModal);
  };

  useEffect(() => {
    // Fetch dynamic caste list if available
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`)
      .then((response) => {
        if (Array.isArray(response.data?.data?.caste) && response.data.data.caste.length > 0) {
          setCasteOptions(response.data.data.caste);
        }
      })
      .catch((err) => {
        console.log("Using default caste options:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "lookingFor") {
      setFormData((prev) => {
        const genderMin = Math.max(AGE_SCALE_MIN, getMinAgeForGender(value));
        if (prev.minAge >= genderMin) return { ...prev, lookingFor: value };
        return {
          ...prev,
          lookingFor: value,
          minAge: genderMin,
          maxAge: Math.max(prev.maxAge, genderMin + 1),
        };
      });
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAgeMeterChange = (minAge, maxAge) => {
    setFormData((prev) => {
      const nextMin = Math.max(minAge, AGE_SCALE_MIN, getMinAgeForGender(prev.lookingFor));
      return {
        ...prev,
        minAge: nextMin,
        maxAge: Math.max(maxAge, nextMin + 1),
      };
    });
  };

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Format height (5.6 => 5'6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const [feet, inches] = height.split(".");
    return `${feet}'${inches}"`;
  };

  const formatGender = (gender) => {
    if (!gender) return "N/A";
    const normalized = String(gender).trim().toLowerCase();
    if (normalized === "male") return "Male";
    if (normalized === "female") return "Female";
    return gender;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = new FormData();
    payload.append("gender", formData.lookingFor);
    payload.append("min_age", formData.minAge);
    payload.append("age", formData.maxAge);
    if (formData.caste && formData.caste !== "Select") {
      payload.append("caste", formData.caste);
    }
    if (formData.motherTongue) {
      payload.append("language", formData.motherTongue);
    }
    if (formData.state && formData.state !== "Select State") {
      payload.append("state", formData.state);
      payload.append("city", formData.state);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_search`,
        payload
      );
      if (response.data?.response === "success" && Array.isArray(response.data.users)) {
        setApiData(response.data);
      } else {
        setApiData({ users: [], match_type: "none" });
      }
      handleModal();
    } catch (err) {
      console.error("Error fetching matching profiles:", err);
      // Even if API errors, show modal with fallback message / search option
      setApiData({});
      handleModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="luxury-hero-section">
        {/* Luxury Hero Banner Slider (Desktop & Mobile Responsive) */}
        <div className="luxury-hero-slider-wrapper">
          <button
            type="button"
            className="hero-slider-nav-btn hero-slider-prev"
            aria-label="Previous banner"
          >
            <FiChevronLeft />
          </button>

          <button
            type="button"
            className="hero-slider-nav-btn hero-slider-next"
            aria-label="Next banner"
          >
            <FiChevronRight />
          </button>

          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            className="luxury-hero-slider"
            effect="fade"
            fadeEffect={{ crossFade: true }}
            speed={900}
            loop={HERO_SLIDES.length > 1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              prevEl: ".hero-slider-prev",
              nextEl: ".hero-slider-next",
            }}
          >
            {HERO_SLIDES.map((slide, idx) => (
              <SwiperSlide key={slide.id}>
                <picture className="hero-slide-picture">
                  <source media="(max-width: 767.98px)" srcSet={slide.mobile} />
                  <img
                    src={slide.desktop}
                    alt={slide.alt}
                    className="hero-slide-img"
                    loading={idx === 0 ? "eager" : "lazy"}
                    fetchPriority={idx === 0 ? "high" : "auto"}
                  />
                </picture>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Floating Search Finder Card */}
        <div className="finder-floating-wrapper">
          <div className="container">
            <div className="luxury-finder-card">
              {/* Corner Gold Flourish */}
              <div className="finder-corner-ornament" />

              {/* Finder Header */}
              <div className="finder-card-header">
                <div className="finder-header-left">
                  <div className="finder-search-circle-icon">
                    <FiSearch />
                  </div>
                  <h3 className="finder-title">Find Your Perfect Match</h3>
                  <span className="finder-subtitle">Begin your journey to a beautiful relationship</span>
                </div>
              </div>

              {/* Finder Search Form */}
              <form onSubmit={handleSubmit} className="finder-form">
                <div className="finder-fields-grid">
                  {/* Field 1: I am looking for */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiUser className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">I am looking for</label>
                      <FinderSelect
                        name="lookingFor"
                        value={formData.lookingFor}
                        onChange={handleChange}
                        options={LOOKING_FOR_OPTIONS}
                        ariaLabel="I am looking for"
                      />
                    </div>
                  </div>

                  {/* Field 2: Age Meter */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiCalendar className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">Age</label>
                      <AgeMeter
                        minAge={formData.minAge}
                        maxAge={formData.maxAge}
                        minLimit={AGE_SCALE_MIN}
                        maxLimit={AGE_SCALE_MAX}
                        onChange={handleAgeMeterChange}
                      />
                    </div>
                  </div>



                  {/* Field 4: Mother Tongue */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiMessageSquare className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">Mother Tongue</label>
                      <FinderSelect
                        name="motherTongue"
                        value={formData.motherTongue}
                        onChange={handleChange}
                        options={motherTongueOptions}
                        ariaLabel="Mother Tongue"
                      />
                    </div>
                  </div>

                  {/* Field: State */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiMapPin className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">State</label>
                      <FinderSelect
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        options={stateOptions}
                        ariaLabel="State"
                      />
                    </div>
                  </div>

                  {/* Search Button */}
                  <div className="finder-action-box">
                    <button
                      type="submit"
                      className="finder-submit-btn"
                      disabled={loading}
                    >
                      <FiSearch className="btn-search-icon" />
                      <span>{loading ? "Searching..." : "Search Now"}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Social Proof Bar */}
            <div className="hero-social-proof-bar">
              <div className="social-proof-content">
                <span className="proof-text-strong">Trusted by 50,000+ Families</span>
                <div className="proof-avatar-stack">
                  <img src={user1} alt="Member" className="avatar-img" />
                  <img src={user2} alt="Member" className="avatar-img" />
                  <img src={user3} alt="Member" className="avatar-img" />
                  <img src={user4} alt="Member" className="avatar-img" />
                  <img src={user5} alt="Member" className="avatar-img" />
                  <span className="avatar-count-badge">50K+</span>
                </div>
                <span className="proof-text-muted">and counting...</span>
              </div>
              <div className="proof-bottom-heart">
                <FaHeart className="small-heart-accent" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search Results Modal */}
      <Modal
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={false}
        show={isOpenModal}
        size="xl"
        onHide={handleModal}
        className="luxury-results-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-dark fs-4">
            Matching Profiles for You
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          {apiData?.match_type && apiData.match_type !== "exact" && apiData?.users?.length > 0 && (
            <p className="text-muted small mb-3">
              {apiData.match_type === "nearby"
                ? "Showing closest matches for your age, community, and language. City filter was relaxed."
                : apiData.match_type === "community"
                ? "Showing closest matches for your age and community. Language and city filters were relaxed."
                : "Showing the closest matches for your selected age and partner preference."}
            </p>
          )}
          <div className="row g-3">
            {!apiData?.users || apiData?.users?.length === 0 ? (
              <div
                className="position-relative nodataBox w-100 py-5 text-center"
                style={{
                  backgroundImage: `url(${NoDataImage})`,
                  backgroundSize: "cover",
                  borderRadius: "12px",
                }}
              >
                <div className="py-4">
                  <h3 className="text-white fw-bold mb-3">No Immediate Match Found</h3>
                  <p className="text-white-50 mb-4">Try broadening your search criteria or explore recently joined members.</p>
                  <div className="d-flex justify-content-center gap-3">
                    <Button onClick={handleModal} variant="light" className="px-4 fw-bold">
                      Modify Search
                    </Button>
                    <Link to="/recently-joined-matches/" className="btn btn-danger px-4 fw-bold">
                      View All Members
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              apiData.users.map((member) => (
                <Link
                  to="/login"
                  key={member.user_id}
                  className="col-12 col-sm-6 col-md-4 col-lg-3 text-decoration-none"
                >
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden member-result-card">
                    <div className="member-photo-wrapper position-relative">
                      <MemberPhotoSlider
                        images={getUserImages(member)}
                        alt={member.name}
                        imageClassName="member-result-image"
                      />
                      <span className="badge bg-danger position-absolute top-0 end-0 m-2 rounded-pill member-result-id">
                        HS{member.user_id}
                      </span>
                    </div>
                    <div className="card-body p-3">
                      <div className="text-muted small mb-2">
                        {calculateAge(member.dob)} Yrs • {formatHeight(member.height)} • {formatGender(member.gender)}
                      </div>
                      <div className="d-flex flex-column gap-1 small text-secondary">
                        <div>
                          <strong>Caste:</strong> {member.caste || "Hindu"}
                        </div>
                        <div>
                          <strong>Language:</strong> {member.language || "N/A"}
                        </div>
                        <div>
                          <strong>Location:</strong> {member.curr_location || member.city || member.country || "India"}
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn btn-outline-danger btn-sm w-100 rounded-pill fw-bold">
                          View Full Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

